import api from '@utils/api';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const LoginJoinMoncler = (props) => {
    const { t } = useTranslation();
    const [componentList, setComponentList] = useState([]);
    const [currentComponent, setCurrentComponent] = useState();
    useEffect(() => {
        api.getPageJson('benefits-box', true).then((data) => {
            var _a, _b, _c, _d, _e;
            const component = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.regions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.find((el) => el.type_id === 'component_benefits_box');
            const componentList = (_e = (_d = component === null || component === void 0 ? void 0 : component.regions) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.components;
            if (component)
                setCurrentComponent(component);
            if (componentList)
                setComponentList(componentList);
        });
    }, []);
    if (!currentComponent || !componentList) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames('login-registration__join-moncler', props.classNames) },
        React.createElement("p", { className: "bold mb-16 primary-s" }, currentComponent.data.title),
        React.createElement("ul", { className: "register-list mb-16" }, componentList.map((component) => (React.createElement("li", { className: "primary-xxs", key: component.id },
            React.createElement("img", { src: component.custom.image, alt: "" }),
            component.data.title)))),
        ((currentComponent.data.link && props.inModal) || props.showCTA) && (React.createElement("a", { href: currentComponent.data.link, className: "button" },
            currentComponent.data.linkText,
            React.createElement("span", { className: "icon--chevron-small-right" })))));
};
export default LoginJoinMoncler;
